
import {GoingUtils,AssertUtils} from "goingutils";


//设置按钮不可以点击
function _setBtnDisable(pageToolBarId) {
    $(`#${pageToolBarId} .pagin-btn`).each(function () {
        $(this)
            .parent()
            .removeClass("dhxtoolbar_btn_def");
        $(this)
            .parent()
            .addClass("dhxtoolbar_btn_dis");
    });
}

//设置按钮可以点击
function _setBtnEnable(pageToolBarId) {
    $(`#${pageToolBarId} .pagin-btn`).each(function () {
        $(this)
            .parent()
            .removeClass("dhxtoolbar_btn_dis");
        $(this)
            .parent()
            .addClass("dhxtoolbar_btn_def");
    });
}

//设置左边按钮不可以点击
function _setLeftBtnDisable(pageToolBarId) {
    $(`#${pageToolBarId} .left-btn.pagin-btn`).each(function () {
        $(this)
            .parent()
            .removeClass("dhxtoolbar_btn_def");
        $(this)
            .parent()
            .addClass("dhxtoolbar_btn_dis");
    });
}

//设置右边按钮不可以点击
function _setRightBtnDisable(pageToolBarId) {
    $(`#${pageToolBarId} .right-btn.pagin-btn`).each(function () {
        $(this)
            .parent()
            .removeClass("dhxtoolbar_btn_def");
        $(this)
            .parent()
            .addClass("dhxtoolbar_btn_dis");
    });
}

//分页栏控件
export default class GoingPagin {
    constructor(containerId, hideFlag, targetObj) {
        var options = {
            pageSize: [20,30, 50, 100, 300, 500, 1000],
            pageSel: true,
            pageCountSel: true
        };
        this.curFirstResult = 0;
        this.pageSize = GoingUtils.pageSizeNumber;
        this.curFirstResult = 0;
        this.targetObj = targetObj;
        this.paginType = targetObj.paginType;
        this.curPageSize = targetObj.pageSize;
        if (!AssertUtils.isNotEmpty(targetObj.pageSize)) {
            this.curPageSize = GoingUtils.pageSizeNumber;
        }
        this.pageCount = 0;
        this.pagingContainerId = containerId;
        this.initPaginContainer(options);
        $("#" + this.pagingContainerId).css("backgroundColor", "#FFF");
    }

    initPaginContainer(options) {
        this.pageToolBarId = GoingUtils.getUUid(14);
        var pagingHtml =
            '<div id="' +
            this.pageToolBarId +
            '" class="go-pagin-bar dhxtoolbar_float_left clearfix">' +
            '<div class="pagin-right-cell">' +
            this.getTotalHtml() +
            this.getLeftImg() +
            this.getPageText() +
            this.getRightImg() +
            this.getPageCountSel() +
            this.getPageSel() +
            "</div>" +
            "</div>";

        $("#" + this.pagingContainerId).addClass(
            "dhx_toolbar_dhx_" + GoingUtils.getCurSysSkins() + " dhxtoolbar_icons_18"
        );
        $("#" + this.pagingContainerId).html(pagingHtml);
        this.initPaginState(options);
        this.initPageSelCtl();
        this.initPageCountSelCtl(options);
        this.initPageImgEvent();
        this.setSizes();
        //如果是简单 分页条
        if (this.paginType === "simplePagin") {
            //将页数选择选项隐藏
            $("#" + this.recordPaginsId).hide();
            //将多少条每页选择选项隐藏
            $("#" + this.recordSelOptId).hide();
        }
    }

    /**
     * 根据宽度大小控制分页的显示
     */
    setSizes() {
        let paginWid = $("#" + this.pageToolBarId).css("width");
        if (parseFloat(paginWid) > 300 && parseFloat(paginWid) < 440) {
            $("#" + this.pageToolBarId)
                .find(".pagin-right-cell")
                .show();
            $("#" + this.pageToolBarId)
                .find(".pagin-sel-ctl")
                .hide();
        } else if (parseFloat(paginWid) > 0 && parseFloat(paginWid) < 300) {
            $("#" + this.pageToolBarId)
                .find(".pagin-right-cell")
                .hide();
        } else {
            $("#" + this.pageToolBarId)
                .find(".pagin-sel-ctl")
                .show();
            $("#" + this.pageToolBarId)
                .find(".pagin-right-cell")
                .show();
        }
    }

    //初始化分页工具栏
    initPaginCtl(totalCount = 0) {
        this.curPageSize = this.targetObj.curPageSize||this.targetObj.pageSize;
        this.curFirstResult = this.targetObj.curFirstResult;
        this.pageCount =
            parseInt(this.curFirstResult + "") / parseInt(this.curPageSize + "");
        var pageSize = Math.ceil(parseInt(totalCount + "") / this.curPageSize);
        //如果删除的时候 会出现当前查询的数据等于了记录开始记录 则需要翻页到前面一页
        if(pageSize*this.curPageSize===this.curFirstResult&&this.curFirstResult!==0){
            this.paginToPre();
            return void(0);
        }
        if (pageSize >= 1) {
            this.addPageSizSel(pageSize);
        }
        this.setPageText(totalCount);
        $("#" + this.recordPaginsId + "_text").html(
            "页数 " + (parseInt(this.pageCount + "") + 1)
        );
        this.initPageImgState(pageSize);
    }

    initPageImgState(pageSize) {
        //先设置按钮可以点击
        _setBtnEnable(this.pageToolBarId);
        //如果只有一页数据则 左右按钮都不可以点

        if (pageSize == 1) {
            _setBtnDisable(this.pageToolBarId);
        }else if(pageSize===0){
            _setLeftBtnDisable(this.pageToolBarId);
            _setRightBtnDisable(this.pageToolBarId);
        } else {
            //如果页面数据大于1 则需要根据当前的pageCode来设置 按钮状态
            if (this.pageCount == 0) {
                _setLeftBtnDisable(this.pageToolBarId);
            }
            if (this.pageCount == parseInt(pageSize + "") - 1) {
                _setRightBtnDisable(this.pageToolBarId);
            }
        }
    }

    getPageSelHtml(pageSize) {
        this.pageSize = pageSize;
        var pageHtmlAry = [];
        for (var num = 0; num < pageSize; num++) {
            pageHtmlAry.push(
                '<tr class="tr_btn" style="height:24px;" pageCount="' +
                (num + 1) +
                '">' +
                '<td><i class="fa fa-clipboard"></i></td><td class="td_btn_txt">' +
                '<span style="padding: 0 1px 0 0;">页数 ' +
                (num + 1) +
                "</span></td></tr>"
            );
        }
        return pageHtmlAry.join("\n");
    }

    addPageSizSel(pageSize) {
        var paginObj = this;
        $("#" + this.pagingContainerId + "_page").remove();
        var skin = GoingUtils.getCurSysSkins();
        let zIndex = 105;
        var pageHtml =
            '<div dir="ltr" id="' +
            this.pagingContainerId +
            '_page"' +
            ' class="dhx_toolbar_poly_' +
            skin +
            ' dhxtoolbar_icons_18 dhx_toolbar_shadow go-pagin-sel-div" ' +
            ' type="paginCtl" style="overflow-y: auto; display:none; z-index: ' +
            zIndex +
            '; width:110px; height: auto;background-color: #FFF;">' +
            '<table class="buttons_cont" cellspacing="0" cellpadding="0" border="0" style="width: 100%"><tbody>' +
            this.getPageSelHtml(pageSize) +
            "</tbody></table></div>";

        var gridId = this.targetObj.gridId;
        if($("#"+gridId).parent().get(0)!=null){
            $(pageHtml).appendTo($("#"+gridId).parent());
        }else{
            $(pageHtml).appendTo($("#main_router_view"));
        }
        $("#" + this.pagingContainerId + "_page")
            .find(".tr_btn")
            .click(function () {
                var pageCount = $(this).attr("pageCount");
                $("#" + paginObj.recordPaginsId + "_text").html("页数 " + pageCount);
                paginObj.setPage(parseInt(pageCount + "") - 1);
            });
    }

    setPage(pageCount) {
        this.pageCount = pageCount;
        this.targetObj.curFirstResult = pageCount * this.curPageSize;
        this.targetObj.curPage = pageCount + 1;
        this.targetObj.reloadData();
    }

    setPageText(totalCount) {
        var startNum =
            parseInt(this.curPageSize + "") * parseInt(this.pageCount + "") + 1;
        var endNum =
            parseInt(this.curPageSize + "") * parseInt(this.pageCount + 1 + "");
        if (endNum > totalCount) {
            endNum = totalCount;
        }
        if (endNum > 0) {
            $("#" + this.gridPaginInfoId).html("当前 " + startNum + " 到 " + endNum);
        } else {
            $("#" + this.gridPaginInfoId).html("当前 " + 0 + " 到 " + 0);
        }

        $(`#${this.pageToolBarId}_total`).html(`总数：${totalCount}`);
    }

    getPageText() {
        this.gridPaginInfoId = GoingUtils.getUUid(12);
        return (
            '<div  class="dhx_toolbar_text record-count-info" title="">' +
            '<div id="' +
            this.gridPaginInfoId +
            '" style="width:100%; text-align:center">当前 0 到 0</div>' +
            "</div>"
        );
    }

    getTotalHtml() {
        return (
            '<div  title="" style="float:left;margin-right: 10px;line-height: 27px;margin-top:1px;" id="' +
            this.pageToolBarId +
            '_total">总数：0</div>'
        );
    }

    initPageImgEvent() {
        var goingPagin = this;
        $(`#${this.pageToolBarId} .pagin-btn`).click(function () {
            if (
                ($(this).parent()).attr("class").indexOf("dhxtoolbar_btn_dis") > 0
            ) {
                return false;
            } else {
                var src = $(this).attr("src");
                if (src === "ar_right") {
                    goingPagin.paginToNext();
                } else if (src === "ar_right_abs") {
                    goingPagin.paginToEnd();
                } else if (src === "ar_left") {
                    goingPagin.paginToPre();
                } else if (src === "ar_left_abs") {
                    goingPagin.paginToFirst();
                }
            }
        });
    }

    initPageSelCtl() {
        var pagingContainerId = this.pagingContainerId;
        $("#" + this.recordPaginsId).click(function (event) {

            $(".dhxtoolbar_btn_click").removeClass("dhxtoolbar_btn_click");

            var {x, y} = GoingUtils.getElementPosition(this);
            var floatTop = y - 50;
            var floatLeft = x - 50;

            var pageSelObj = $("#" + pagingContainerId + "_page").get(0);
            var elHeight = $(pageSelObj).css("height");
            if (pageSelObj != null) {
                $(pageSelObj).show();
                $(pageSelObj).css("top", floatTop - parseInt(elHeight) + 40);
                $(pageSelObj).css("left", floatLeft);
            }

            var $parentObj = $(this);
            $parentObj.addClass("dhxtoolbar_btn_click");
            var nextObj = $parentObj.next();
            var nextClass = $(nextObj[0]).attr("class");
            if (nextClass != null && nextClass.indexOf("dhx_toolbar_arw") >= 0) {
                $(nextObj[0]).addClass("dhxtoolbar_btn_click");
            }

            event.stopPropagation();
        });
    }

    getPageSelHtmls(options) {
        var items = options["pageSize"];
        var recordsRowHtml = "";
        for (var num = 0; num < items.length; num++) {
            var recordRowHtml =
                '<tr class="tr_btn">' +
                '<td class="td_btn_img">' +
                `<i class="fa fa-clipboard"></i>` +
                '<td class="td_btn_txt">' +
                '<div class="btn_sel_text">' +
                '<span class="recordsSpan" count="' +
                items[num] +
                '" style="padding: 0 4px 0 0;">' +
                items[num] +
                " 条/页</span>" +
                "</div>" +
                "</td>" +
                "</tr>";
            recordsRowHtml = recordsRowHtml + recordRowHtml;
        }
        return recordsRowHtml;
    }

    initPageCountSelCtl(options) {
        var targetObj = this.targetObj;
        var paginObj = this;
        var initEvent = function (targetObj) {
            $(".tr_btn").mouseover(function () {
                $(this).addClass("tr_btn_over");
            });
            $(".tr_btn").mouseout(function () {
                $(this).removeClass("tr_btn_over");
            });
            var _recordSelOptIdDiv = paginObj.recordSelOptId + "_Div";

            $("#" + _recordSelOptIdDiv + " .tr_btn").click(function () {
                var count = $(this)
                    .find(".recordsSpan")
                    .attr("count");
                targetObj.curFirstResult = 0;
                targetObj.curPageSize = parseInt(count + "");
                targetObj.reloadData();
                $("#" + _recordSelOptIdDiv).css("display", "none");
                $("#" + paginObj.recordSelOptId).html(
                    "" + '<div class="dhxtoolbar_text">' + count + "条/页</div>"
                );
            });

            $("#" + paginObj.recordSelOptId).click(function (event) {
                var skin = GoingUtils.getCurSysSkins();
                $(".dhx_toolbar_poly_dhx_" + skin + "").css("display", "none");

                $(".dhxtoolbar_btn_click").removeClass("dhxtoolbar_btn_click");
                var $parentObj = $(this);
                $parentObj.addClass("dhxtoolbar_btn_click");
                var nextObj = $(this);
                var nextClass = $(nextObj[0]).attr("class");
                if (nextClass != null && nextClass.indexOf("dhx_toolbar_arw") >= 0) {
                    $(nextObj[0]).addClass("dhxtoolbar_btn_click");
                }
                $("#" + _recordSelOptIdDiv)
                    .css("display", "block")
                    .css("right", `${60}px`)
                    .css("top", `${0 - 178}px`)
                    .css("zIndex", GoingUtils.getCurMaxZIndex());
                event.stopPropagation();
            });

            var skin = GoingUtils.getCurSysSkins();
            $("*").click(function () {
                var curClickClass = $(this).attr("class"); //显示鼠标点击的元素的id
                if (
                    curClickClass != null &&
                    curClickClass.indexOf("dhxtoolbar_btn_click") >= 0
                ) {
                    return;
                } else {
                    $(".dhx_toolbar_poly_material[type='paginCtl']").css(
                        "display",
                        "none"
                    );
                    $(".dhx_toolbar_poly_dhx_" + skin + "[type='paginCtl']").css(
                        "display",
                        "none"
                    );
                    $(".dhxtoolbar_btn_click").removeClass("dhxtoolbar_btn_click");
                }
            });
        };
        var skin = GoingUtils.getCurSysSkins();
        var bodyHeight = document.body.clientHeight;
        if (AssertUtils.isNotNull($("#" + this.recordSelOptId).get(0))) {
            var recordsSelDivPos = GoingUtils.getElementPosition(
                $("#" + this.recordSelOptId).get(0)
            );
            var floatTop = recordsSelDivPos[1];
            var floatLeft = recordsSelDivPos[0];
            if (bodyHeight - recordsSelDivPos[1] < 150) {
                floatTop = recordsSelDivPos[1] - 152;
            } else {
                floatTop = recordsSelDivPos[1] + 20;
            }

            var recordsSelHtml =
                '<div id="' +
                this.recordSelOptId +
                '_Div" dir="ltr" type="paginCtl" class="go-pagin-sel-div dhx_toolbar_poly_dhx_' +
                skin +
                ' dhxtoolbar_icons_18"' +
                ' style="overflow-y: auto; top: ' +
                floatTop +
                "px;display:none;visibility: visible; z-index: 105; width: auto; height: auto; left: " +
                floatLeft +
                'px;">' +
                '<table class="buttons_cont" cellspacing="0" cellpadding="0" border="0">' +
                "<tbody>";
            var recordSelHtmls = this.getPageSelHtmls(options);
            var recordsSelBotHtml = "</tbody>" + "</table>" + "</div>";
            var htmls = recordsSelHtml + recordSelHtmls + recordsSelBotHtml;

            var gridId = this.targetObj.gridId;
            if($("#girdPaging"+gridId).get(0)!=null){
                $(htmls).appendTo($("#girdPaging"+gridId).get(0));
            }else{
                $(htmls).appendTo($("#main_router_view"));
            }

            initEvent(targetObj);
        }
    }

    getPageCountSel() {
        this.recordSelOptId = GoingUtils.getUUid(12);
        return (
            '<div id="' +
            this.recordSelOptId +
            '" style="border:1px solid #dfdfdf;padding: 0 10px;margin-left:5px;"  class="pagin-sel-ctl dhx_toolbar_btn dhxtoolbar_btn_def" title="">' +
            '<div class="dhxtoolbar_text">' +
            this.curPageSize +
            "条/页</div>" +
            "</div> " +
            '<div class="dhx_toolbar_arw dhxtoolbar_btn_def" title="">  ' +
            '<div class="arwimg">&nbsp;</div>  ' +
            "</div>"
        );
    }

    getPageSel() {
        this.recordPaginsId = GoingUtils.getUUid(12);
        return (
            '<div id="' +
            this.recordPaginsId +
            '"  class="pagin-sel-ctl dhx_toolbar_btn dhxtoolbar_btn_def" style=" border:1px solid #dfdfdf;padding:0 10px" title="">' +
            '<div class="dhxtoolbar_text" id="' +
            this.recordPaginsId +
            '_text">页数 1</div>' +
            "</div>" +
            '<div class="dhx_toolbar_arw dhxtoolbar_btn_def" title=""> ' +
            '<div class="arwimg">&nbsp;</div> ' +
            "</div> "
        );
    }

    getRightImg() {
        return (
            '<div id="ar_right_div" class="dhx_toolbar_btn dhxtoolbar_btn_def" title=""> ' +
            `<a class="right-btn pagin-btn" src="ar_right" href="javascript:void(0)" title="Next"><i class="ivu-icon ivu-icon-ios-arrow-forward"></i></a>` +
            "</div> " +
            '<div class="dhx_toolbar_btn dhxtoolbar_btn_def" title="">' +
            `<a class="right-btn pagin-btn" src="ar_right_abs" href="javascript:void(0)" title="Last"><i class="ivu-icon ivu-icon-ios-skip-forward"></i></a>` +
            "</div>"
        );
    }

    getLeftImg() {
        return (
            '<div class="dhx_toolbar_btn dhxtoolbar_btn_def" title="">' +
            `<a class="left-btn pagin-btn" src="ar_left_abs" href="javascript:void(0)" title="Last"><i class="ivu-icon ivu-icon-ios-skip-backward"></i></a>` +
            "</div>" +
            '<div class="dhx_toolbar_btn dhxtoolbar_btn_def" title="">' +
            `<a class="left-btn pagin-btn"  src="ar_left" href="javascript:void(0)" title="Next"><i class="ivu-icon ivu-icon-ios-arrow-back"></i></a>` +
            "</div>"
        );
    }

    initPaginState(options) {
        if (options["pageCountSel"] == false) {
            $("#" + this.recordSelOptId).hide();
        }
        if (options["pageSel"] == false) {
            $("#" + this.recordPaginsId).hide();
        }
    }

    paginToPre() {
        var paginObj = this;
        paginObj.setPage(this.pageCount - 1);
    }

    paginToFirst() {
        var paginObj = this;
        paginObj.setPage(0);
    }

    paginToNext() {
        var paginObj = this;
        paginObj.setPage(this.pageCount + 1);
    }

    paginToEnd() {
        var paginObj = this;
        paginObj.setPage(this.pageSize - 1);
    }
}



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/extend/goingPagin.js